import { render, staticRenderFns } from "./LoadedContentWrapper.vue?vue&type=template&id=2ebd1bd8&lang=pug&"
import script from "./LoadedContentWrapper.vue?vue&type=script&lang=js&"
export * from "./LoadedContentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./LoadedContentWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports